import { alpha } from "@mui/material/styles";

// Toggle groups are segmented controls: a grey track with borderless options,
// the selected one raised in white. At size="small" the track is 40px tall so
// it lines up with the text fields and selects it usually sits next to in a
// filter bar.
const TRACK_PADDING = 3;

export const MuiToggleButton = (mode) => {
  return {
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: TRACK_PADDING,
          gap: TRACK_PADDING,
          borderRadius: theme.shape.borderRadius * 3,
          backgroundColor: alpha(theme.palette.text.primary, theme.palette.mode === "light" ? 0.06 : 0.12),
        }),
        // The default grouped styling joins the options with shared borders
        // and squares off the inner corners; each option is its own pill here
        grouped: ({ theme }) => ({
          border: 0,
          margin: 0,
          borderRadius: theme.shape.borderRadius * 2,
        }),
        firstButton: ({ theme }) => ({ borderRadius: theme.shape.borderRadius * 2 }),
        middleButton: ({ theme }) => ({ borderRadius: theme.shape.borderRadius * 2, marginLeft: 0, borderLeft: 0 }),
        lastButton: ({ theme }) => ({ borderRadius: theme.shape.borderRadius * 2, marginLeft: 0, borderLeft: 0 }),
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: 0,
          borderRadius: theme.shape.borderRadius * 2,
          textTransform: "none",
          fontWeight: 600,
          color: theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: "transparent",
            color: theme.palette.text.primary,
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.12)}`,
          },
          // MUI outlines disabled options, which boxes in every unselected
          // option of a read-only group
          "&.Mui-disabled": {
            border: 0,
          },
        }),
        sizeSmall: {
          padding: "5px 14px",
          fontSize: "14px",
          lineHeight: "24px",
        },
      },
    },
  };
};
